/**
 * 官网博客（匿名接口，与 beauty-ui 后台同源）
 */
export function fetchPublicBlogList() {
  const prefix = process.env.VUE_APP_BASE_API || ''
  return fetch(prefix + '/web/blog/public/list', {
    method: 'GET',
    headers: { Accept: 'application/json' },
  })
    .then((res) => res.json())
    .then((body) => {
      if (body.code !== 200) {
        throw new Error(body.msg || '加载失败')
      }
      return Array.isArray(body.data) ? body.data : []
    })
}

/**
 * @param {string|number} id
 */
export function fetchPublicBlogDetail(id) {
  const prefix = process.env.VUE_APP_BASE_API || ''
  return fetch(prefix + '/web/blog/public/detail/' + encodeURIComponent(id), {
    method: 'GET',
    headers: { Accept: 'application/json' },
  })
    .then((res) => res.json())
    .then((body) => {
      if (body.code !== 200) {
        throw new Error(body.msg || '加载失败')
      }
      return body.data || null
    })
}
